<script setup lang="ts">
    import BaseButton from '@/components/BaseButton.vue';
    import ColorChart from '@/components/ColorChart.vue';
    import { useElementPosition } from '@/composables/useElementPosition';
    import { computed, ref, useTemplateRef } from 'vue';
    import { onClickOutside } from '@vueuse/core';
    const model = defineModel<string>({ default: '#000000' });
    const isOpen = ref(false);
    const wrapperRef = useTemplateRef('pickerWrapper');
    const colorChartRef = useTemplateRef('colorChartRef');
    const buttonRef = useTemplateRef('buttonRef');

    const { style } = useElementPosition(wrapperRef);

    const colorStyle = computed(() => {
        return {
            backgroundColor: model.value,
        };
    });

    function toggleVisibility() {
        isOpen.value = !isOpen.value;
    }

    onClickOutside(
        colorChartRef,
        () => {
            isOpen.value = false;
        },
        {
            ignore: [buttonRef],
        },
    );
</script>
<template>
    <div ref="pickerWrapper">
        <BaseButton
            ref="buttonRef"
            variant="text"
            class="h-8 w-8 focus:bg-black"
            @click="toggleVisibility"
        >
            <span class="sr-only"> {{ $t('color_picker') }} </span>
            <span
                class="h-5 w-5 rounded-full border border-border-primary"
                :style="colorStyle"
            ></span>
        </BaseButton>
        <Teleport
            v-if="isOpen"
            to="body"
        >
            <div
                ref="colorChartRef"
                :class="['border-border fixed z-10 rounded-md border bg-white']"
                :style
            >
                <ColorChart v-model="model" />
            </div>
        </Teleport>
    </div>
</template>
